import { Wrapper } from "@quest/platform-murka-phase_2/dist";

export class WrapperController extends Wrapper {
    // 
    // 
}
